import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import CascadingMenuButton from "../CascadingMenuButton.js";
import { getAccountLabel, isAdminMode } from "./util.js";
function AccountToggleButton({ account, }) {
    return (_jsx(Tooltip, { title: account.name, children: _jsx(ToggleButton, { value: account.internetAccountId, children: getAccountLabel(account) }) }));
}
function MoreButton({ onClick, disabled, children, }) {
    return (_jsx(ToggleButton, { value: "more", selected: false, disabled: disabled, onClick: e => {
            onClick(e);
        }, children: children }));
}
export default function SourceTypeSelector({ value, shownAccountIds, hiddenAccountIds, accountMap, onChange, onHiddenAccountSelect, }) {
    const shownAccounts = shownAccountIds.map(id => accountMap[id]);
    const hiddenAccounts = hiddenAccountIds.map(id => accountMap[id]);
    return (_jsxs(ToggleButtonGroup, { value: value, exclusive: true, size: "small", onChange: onChange, "aria-label": "file, url, or account picker", children: [!isAdminMode() && (_jsx(ToggleButton, { value: "file", "aria-label": "local file", children: "File" })), _jsx(ToggleButton, { value: "url", "aria-label": "url", children: "URL" }), shownAccounts.map(account => (_jsx(AccountToggleButton, { account: account }, account.internetAccountId))), hiddenAccounts.length > 0 && (_jsxs(CascadingMenuButton, { menuItems: hiddenAccounts.map(account => ({
                    label: account.name,
                    onClick: () => {
                        onHiddenAccountSelect(account.internetAccountId);
                    },
                })), ButtonComponent: MoreButton, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' }, children: ["More", _jsx(ArrowDropDownIcon, {})] }))] }));
}
